export const getZipMenuVisibleState = (state) => state.file.showZipMenu;
